module.exports = __webpack_public_path__ + "img/huankuanchenggong.0975e16f.png";